'use client';
import { useState, useEffect, ChangeEvent, useContext } from 'react';
// import { useGlobalContext } from '../../contexts/auth-context';
import CongratulationModal from './congratulationModal';
import SeedPhraseModal from './seedPhraseModal';
import PasswordlessModal from './passwordlessModal';
import { ModalContext } from '../../contexts/modal-provider';
import LandModal from './landModal';
import { useTranslations } from 'next-intl';
import ShowRecoveryModal from './showRecoveryModal';

const OnboardingModal = () => {
  const t = useTranslations('Modals');

  const { modalState, closeModal, openModal, setModalError, error } = useContext(ModalContext);
  // const [password, setPasswordChange] = useState<string>('');
  // const [confirmPassword, setConfirmPasswordChange] = useState<string>('');
  // const [seedPhrase, setSeedPhrase] = useState<string | null>('');
  // const [recoveryKitCount, setRecoveryKitCount] = useState<number>(0);

  // useEffect(() => {
  //   const loadUserData = async () => {
  //     setRecoveryKitCount(await getRecoveryKitCount());
  //   };

  //   if (user && !user.isDecentralized) loadUserData();
  // }, [user]);

  // useEffect(() => {
  //   const initModal = () => {
  //     if (user?.isNewUser) {
  //       openModal({ type: 'NEW_USER_MODAL' });
  //     } else if (recoverAccount && modalState.type !== 'CHANGE_PASSWORD_MODAL') {
  //       openModal({ type: 'PASSWORD_MODAL' });
  //     }
  //   };
  //   initModal();
  // }, [user, recoverAccount]);

  // const handlePasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
  //   setPasswordChange(event.target.value);
  // };

  // const handleConfirmPasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
  //   setConfirmPasswordChange(event.target.value);
  // };

  // const savePassword = async () => {
  //   setModalError('', '');
  //   if (password === confirmPassword) {
  //     try {
  //       if (modalState.type === 'NEW_USER_MODAL') {
  //         await setPassword(password);
  //         openModal({ type: 'CONGRATULATION_MODAL' });
  //       } else {
  //         await updatePassword(password);
  //         setModalError('', '');
  //         closeModal();
  //       }
  //     } catch (error) {
  //       setModalError(t('passwordless.regex-error'), '');
  //     }
  //   } else {
  //     setModalError(t('passwordless.not-match-error'), '');
  //   }
  // };

  // const saveRecoverPassword = async () => {
  //   try {
  //     setModalError('', '');
  //     await recoverFromPassword(password);
  //     closeModal();
  //   } catch (error) {
  //     setModalError(t('passwordless.incorrect-password-error'), '');
  //   }
  // };

  // const saveRecoverSeed = async (seed: string) => {
  //   try {
  //     setModalError('', '');
  //     await recoverFromSeedPhrase(seed);
  //     openModal({ type: 'CHANGE_PASSWORD_MODAL', isTest: true });
  //   } catch (e: any) {
  //     setModalError('', t('seed-phrase.not-match-error'));
  //   }
  // };

  // const closeSeedPhraseModal = async () => {
  //   setModalError('', '');
  //   if (modalState.isTest) {
  //     openModal({ type: 'PASSWORD_MODAL', isTest: false });
  //   } else {
  //     closeModal();
  //   }
  // };

  // const openSeedPhraseModalTest = async () => {
  //   openModal({ type: 'SEED_MODAL', isTest: true });
  // };

  // const showSeedPhrase = async () => {
  //   const seed = await getSeedPhrase();
  //   const recoveryKitCount = await getRecoveryKitCount();
  //   setSeedPhrase(seed);
  //   setRecoveryKitCount(recoveryKitCount);
  //   openModal({ type: 'SEED_MODAL' });
  // };

  return (
    <>
      {/* {modalState.type === 'NEW_USER_MODAL' && (
        <PasswordlessModal
          title={t('passwordless.title')}
          buttonText={t('passwordless.btn-text')}
          description={t('passwordless.description')}
          handlePasswordChange={handlePasswordChange}
          handleConfirmPasswordChange={handleConfirmPasswordChange}
          error={error.passwordlessModalError}
          submitForm={savePassword}
        />
      )}

      {modalState.type === 'CHANGE_PASSWORD_MODAL' && (
        <PasswordlessModal
          title={t('passwordless.new-password')}
          buttonText={t('passwordless.btn-text')}
          description={t('passwordless.change-password-description')}
          handlePasswordChange={handlePasswordChange}
          handleConfirmPasswordChange={handleConfirmPasswordChange}
          error={error.passwordlessModalError}
          submitForm={savePassword}
        />
      )}

      {modalState.type === 'PASSWORD_MODAL' && (
        <PasswordlessModal
          title={t('passwordless.login-title')}
          buttonText={t('passwordless.confirm-password')}
          handlePasswordChange={handlePasswordChange}
          submitForm={saveRecoverPassword}
          enterRecoveryFactor={openSeedPhraseModalTest}
          error={error.passwordlessModalError}
        />
      )}

      {modalState.type === 'CONGRATULATION_MODAL' && (
        <CongratulationModal onClose={() => closeModal()} />
      )}

      {modalState.type === 'SEED_MODAL' && (
        <SeedPhraseModal
          seed={seedPhrase}
          isTest={modalState.isTest || false}
          error={error.seedPhraseRecoveryError}
          onSubmit={saveRecoverSeed}
          onClose={closeSeedPhraseModal}
        />
      )}

      {modalState.type === 'SHOW_RECOVERY' && (
        <ShowRecoveryModal
          recoveryKitCount={recoveryKitCount}
          onShow={showSeedPhrase}
          onClose={() => closeModal()}
          recoveryMaxKitCount={recoveryKit_MAX}
        />
      )} */}

      {modalState.type === 'LAND_MODAL' && <LandModal />}
    </>
  );
};

export default OnboardingModal;
